import { styled } from '@linaria/react';

/** Soft brand-gradient wash that fades out down the top of a Flora landing surface. */
const FloraGradientWash = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 260px;
  background: linear-gradient(
    180deg,
    rgba(255, 230, 54, 0.06) 0%,
    rgba(255, 62, 205, 0.05) 33%,
    rgba(194, 74, 217, 0.04) 66%,
    rgba(87, 92, 229, 0.02) 100%
  );
  pointer-events: none;
  mask-image: linear-gradient(to bottom, black 0%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 0%, transparent 100%);
`;

/** 48px box that haloes the Flora icon with a blurred brand gradient. */
const FloraLogoGlow = styled.div`
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    inset: -10px;
    border-radius: 50%;
    background: linear-gradient(135deg, #FFE636, #FF3ECD, #C24AD9, #575CE5);
    opacity: 0.18;
    filter: blur(14px);
  }
`;

/** 40px Flora icon that sits above `FloraLogoGlow`'s halo. */
const FloraGlowIcon = styled.img`
  width: 40px;
  height: 40px;
  position: relative;
  z-index: 1;
`;

export { FloraGlowIcon, FloraGradientWash, FloraLogoGlow };
